<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Users"
                    />
                    <!-- End Title -->
                </div>
                <div class="w-full md:w-1/2 px-2 md:text-right">
                    <app-button element="button" @click="$router.push({ name: 'users.new' })" class="btn btn--primary btn--primary--sml" v-if="checkPermission('users', 'create')">New User</app-button>
                </div>
            </div>

            <app-box :loading="loading" :initial="loading" v-if="checkPermission('users', 'view')">
                <app-table v-if="users.length > 0">
                    <app-table-header>
                        <app-table-row :header="true">
                            <app-table-cell :header="true">
                                Email
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true" />
                        </app-table-row>
                    </app-table-header>

                    <app-table-body>
                        <app-table-row v-for="(u, i) in users" :key="i">
                            <app-table-cell>
                                {{ u.email }}
                            </app-table-cell>
                            <app-table-cell>
                                <router-link :to="{ name: 'users.edit', params: { id: u.id } }" class="mr-2 text-blue hover:text-blue-darker">
                                    <app-icon icon="edit" v-if="checkPermission('users', 'edit')" />
                                </router-link>
                            </app-table-cell>
                        </app-table-row>
                    </app-table-body>
                </app-table>

                <app-pagination-links
                    :response="response"
                    :resources="menus"
                    @next="selectNextPage"
                    @previous="selectPreviousPage"
                />
            </app-box>
        </app-content>

        </app-content>
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import PaginationLinks from '@/components/PaginationLinks';

    /* Mixins */
    import Query from '@/mixins/query';
    import Paginatable from '@/mixins/paginatable';
    import Permissions from '@/mixins/permissions';

    export default {
        name: 'users.home',

        data: () => ({
            loading: true,
            menus: [],
            users: [],
            response: null,
            confirmModalOpened: false,
            confirmModalId: false,
        }),

        mixins: [ Query, Paginatable, Permissions ],

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-pagination-links': PaginationLinks,
        },

        mounted() {
            this.get().then(response => {
                this.loading = false;
            });
        },

        methods: {
            get() {
                let params = {};

                if (this.$route.query.page) {
                    params.page = this.$route.query.page;
                }

                return Api.request('get', `users?${this.prepareGetQueryString(params)}`)
                    .then(({ data }) => {
                        this.users = data.users;
                        this.response = data;
                    });
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/users/Home.vue